import { render, staticRenderFns } from "./AddCardDialogComponent.vue?vue&type=template&id=8bcc3686&"
import script from "./AddCardDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AddCardDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports